import { setCookie } from 'cookies-next/client';
import { addDays } from 'date-fns';

import { FORCE_EXPERIMENT_VARIANTS_NAME } from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

const headers = import('next/headers');

const COOKIE_CONFIG = {
  path: '/',
  encode: (v: string) => v,
};

export async function setForcedVariantExperiments(experimentNames: string[]) {
  const value = experimentNames.join(',');
  const headersFunction = await headers;

  if (isServerCheck()) {
    (await headersFunction.cookies()).set(
      FORCE_EXPERIMENT_VARIANTS_NAME,
      value,
      {
        ...COOKIE_CONFIG,
        expires: addDays(new Date(), 7),
      }
    );
  } else {
    setCookie(FORCE_EXPERIMENT_VARIANTS_NAME, value, {
      ...COOKIE_CONFIG,
      expires: addDays(new Date(), 7),
    });
  }
}
